/**
 * i18n — react-i18next setup.
 *
 * Namespaces :
 *   common   → mots génériques (actions, états, jours, unités)
 *   dialer   → libellés propres au Dialer (colonnes, filtres, coach, appels)
 *   settings → libellés de Settings (sections, hints, labels de formulaires)
 *
 * Langue par défaut : fr (marché principal B2B France).
 * Bascule : localStorage('xdial_language') > navigateur > 'fr'.
 */

import i18n from 'i18next';
import { BRAND } from '@/config/brand';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonFr from './fr/common.json';
import dialerFr from './fr/dialer.json';
import settingsFr from './fr/settings.json';
import pagesFr from './fr/pages.json';
import adminFr from './fr/admin.json';

import commonEn from './en/common.json';
import dialerEn from './en/dialer.json';
import settingsEn from './en/settings.json';
import pagesEn from './en/pages.json';
import adminEn from './en/admin.json';

const STORAGE_KEY = 'xdial_language';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { common: commonFr, dialer: dialerFr, settings: settingsFr, pages: pagesFr, admin: adminFr },
      en: { common: commonEn, dialer: dialerEn, settings: settingsEn, pages: pagesEn, admin: adminEn },
    },
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    ns: ['common', 'dialer', 'settings', 'pages', 'admin'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React handles escaping
      // {{brand}} in any string is the product name (DESIGN.md §1, F1).
      defaultVariables: { brand: BRAND.name },
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: STORAGE_KEY,
      caches: ['localStorage'],
    },
    returnNull: false,
  });

export default i18n;
export { STORAGE_KEY as LANGUAGE_STORAGE_KEY };
